function configureExchangeRates(opts) {
  void opts.replicantClientPromise.then(async (replicant) => {
    opts.gcinstant.setExchangeRates(replicant.extras.getExchangeRates());
  });
}
export {
  configureExchangeRates
};
